import { render } from "./questioneditortso.vue?vue&type=template&id=25784ff6&scoped=true"
import script from "./questioneditortso.vue?vue&type=script&lang=js"
export * from "./questioneditortso.vue?vue&type=script&lang=js"

import "./questioneditortso.vue?vue&type=style&index=0&id=25784ff6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25784ff6"]])

export default __exports__